import { Button, Container } from '@chakra-ui/react'
import * as React from 'react'

export const ButtonBlock = (props: any) => {
  return (
    <Container maxWidth='6xl' textAlign='center'>
      <Button
        colorScheme='red'
        href={props.button_url}
        as='a'
        target={props.button_target_blank ? '_blank' : undefined}>
        {props.button_text}
      </Button>
    </Container>
  )
}

export default ButtonBlock
